var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-container',{staticClass:"mt-3"},[_c('b-alert',{staticClass:"text-center pre-wrap",attrs:{"show":"","variant":_vm.levelChoices[_vm.publicMessageLevel]}},[_vm._v(" "+_vm._s(_vm.publicMessage)+" ")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }